module.exports = __webpack_public_path__ + "img/changeFineness-1.a265364.png";